import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DayPickerSingleDateController } from 'react-dates'
import moment from 'moment'

import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

import { setDate } from '../../redux/actions/setFilters'
import useWindowSize from '../../utilities/events/useWindowSize'

import '../../styles/scss/components/elements/datepicker.scss'

import nextArrow from '../../assets/icons/calendar-next.svg'
import prevArrow from '../../assets/icons/calendar-prev.svg'
import _ from 'lodash'

const DatePicker = ({ isWeeklyView }) => {
  const eventsData = useSelector(state => state.eventsData)
  const currentDate = useSelector(state => state.filtersData.date)
  const dispatch = useDispatch()

  const handleDateChange = date => {
    dispatch(setDate(date.format('YYYY-MM-DD')))
  }

  const windowSize = useWindowSize()
  const desktopDaySize = Number(process.env.REACT_APP_FORMAT_DATEPICKER_DAY_SIZE_DESKTOP) || 45
  const mobileDaySize = Number(process.env.REACT_APP_FORMAT_DATEPICKER_DAY_SIZE_MOBILE) || 40

  let availableEventsDates = []
  let events = null

  if (
    eventsData &&
    eventsData.data &&
    !_.isEmpty(eventsData.data.events)
  ) {
    events = eventsData.data.events
  }

  if (events) {
    for (let eventKey in events) {
      const currentEvent = events[eventKey]

      if (currentEvent && currentEvent.schedule) {
        for (const scheduleKey in currentEvent.schedule) {

          if (currentEvent.schedule[scheduleKey].startDate) {
            availableEventsDates.push(moment(currentEvent.schedule[scheduleKey].startDate).format('YYYY-MM-DD'))
          }
        }
      }
    }
  }

  const isDayBlocked = day => {
    if (availableEventsDates) {
      availableEventsDates = _.uniq(availableEventsDates)

      const formattedDate = moment(day).format('YYYY-MM-DD')
      const currentDate = availableEventsDates.find(d => d === formattedDate)

      if (currentDate) {
        return false
      }
    }

    // only block calendar dates when displaying events for a single day
    return !isWeeklyView
  }

  const isDayHighlighted = day => {
    if (isWeeklyView) {
      const highlightedStart = moment(currentDate).add(1, 'day')
      const highlightedEnd = highlightedStart.clone().add(5, 'days')
      if (day.isSameOrAfter(highlightedStart, 'day') && day.isSameOrBefore(highlightedEnd, 'day')) {
        return true
      }
    }
    return false
  }

  return (
    <div className="flow-events__datepicker">
      <DayPickerSingleDateController
        date={moment(currentDate)}
        daySize={windowSize.width >= 1280 ? desktopDaySize : mobileDaySize}
        numberOfMonths={windowSize.width >= 1024 ? 1 : windowSize.width >= 700 ? 2 : 1}
        enableOutsideDays={windowSize.width >= 1024 ? true : windowSize.width >= 700 ? false : true}
        focused={true}
        isDayBlocked={isDayBlocked}
        isDayHighlighted={isDayHighlighted}
        isOutsideRange={date => moment(date).isBefore(moment().subtract(1, 'days'))}
        navNext={
          <button className="flow-events__datepicker-arrow next">
            <img src={nextArrow} alt="Date Picker Next" />
          </button>
        }
        navPrev={
          <button className="flow-events__datepicker-arrow prev">
            <img src={prevArrow} alt="Date Picker Prev" />
          </button>
        }
        onDateChange={date => handleDateChange(date)}
        monthFormat={process.env.REACT_APP_FORMAT_DATEPICKER_TITLE_DATE}
      />
    </div>
  )
}

export default DatePicker
